<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MultisportScore.Cricket',
  computed: {
    home() {
      return this.extractScores(this.data?.HomeScore);
    },
    away() {
      return this.extractScores(this.data?.AwayScore);
    },
  },
  methods: {
    extractScores(scoreLine: string) {
      const regex = /(\d+)\/(\d+)\s+\((\d+(?:\.\d+)?)(?:\/(\d+))?\)/;

      const match = scoreLine.match(regex);

      if (match) {
        const [_, runs, wickets, overs, maxOvers] = match;

        return {
          runs: Number(runs),
          wickets: Number(wickets),
          overs: overs.split('.')[0],
          current: overs.split('.')[1],
          maxOvers: maxOvers ? Number(maxOvers) : null,
        };
      }

      return null;
    },
  },
  props: ['data'],
});
</script>

<template>
  <div class="h t">Формат</div>
  <div class="font-mono t">{{ home?.maxOvers || '-' }}</div>
  <div class="b font-mono t">{{ away?.maxOvers || '-' }}</div>

  <div class="h t">Оверов</div>
  <div class="font-mono t">{{ home?.overs }}</div>
  <div class="b font-mono t">{{ away?.overs }}</div>

  <div class="h t">Подача</div>
  <div class="font-mono t">{{ home?.current }}</div>
  <div class="b font-mono t">{{ away?.current }}</div>

  <div class="h t">Оригинал</div>
  <div class="font-mono t">{{ data?.HomeScore }}</div>
  <div class="b font-mono t">{{ data?.AwayScore }}</div>


  <div class="h">Викетов</div>
  <div class="font-mono">{{ home?.wickets }}</div>
  <div class="b font-mono">{{ away?.wickets }}</div>

  <div class="r h">Ранов</div>
  <div class="r font-mono">{{ home?.runs }}</div>
  <div class="r b font-mono">{{ away?.runs }}</div>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 pt-2 pb-1 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &:not(.b) {
      @apply border-b-0;
    }
  }

  & > div.h {
    @apply bg-gray-300 dark:bg-gray-700;
  }
}

.t {
  @apply text-gray-500 text-xs place-content-center !important;
}
</style>
